import { render } from "./TabbedSection.vue?vue&type=template&id=94189f6c"
import script from "./TabbedSection.vue?vue&type=script&lang=js"
export * from "./TabbedSection.vue?vue&type=script&lang=js"

import "./TabbedSection.vue?vue&type=style&index=0&id=94189f6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__